import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../api/auth";

function ConfirmationPage() {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");

    if (!token) {
      setInvalidToken(true);
      return;
    }

    // Confirmation par jeton à usage unique (POST /auth/confirm).
    authApi
      .confirm({ token })
      .then(({ status }) => {
        if (status === 200) {
          setIsConfirmed(true);
        } else {
          setInvalidToken(true);
        }
      })
      .catch(() => {
        setInvalidToken(true);
      });
  }, [location.search]);

  return (
    <div>
      {isConfirmed ? (
        <div className="App d-flex text-center align-items-center justify-content-center vh-100">
          <div className="accessPage h-75 d-flex flex-column text-center align-items-center justify-content-center">
            <h2 className="fw-bold">{t("messageConfirmationUser")}</h2>
            <p>{t("sentenceConfirmationUser")}</p>
            <button
              className="btnConnexion"
              onClick={() => navigate("/Connexion")}
            >
              {t("continueConnexionPage")}
            </button>
          </div>
        </div>
      ) : invalidToken ? (
        <div className="App d-flex text-center align-items-center justify-content-center vh-100">
          <div className="accessPage h-75 d-flex flex-column text-center align-items-center justify-content-center">
            <h2 className="fw-bold">{t("failureConfirmationUser")}</h2>
            <p>{t("sentenceFailureConfirmationUser")}</p>
            <button
              className="btnConnexion"
              onClick={() => navigate("/Connexion")}
            >
              {t("continueConnexionPage")}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ConfirmationPage;
